module.exports = __webpack_public_path__ + "resources/img/img_experdb_en_m.6e6d88674a2dc1cad510dc02f26bc688.png";